export const BASE_URL = 'https://mishnis.net';
export const API_URL = `${BASE_URL}/api`;
export const STORAGE_URL = `${BASE_URL}/storage/`;